import { tv } from 'tailwind-variants';

export const badgeStyle = tv({
  slots: {
    wrapper: '',
    base: 'flex items-center justify-center rounded-full'
  },
  variants: {
    color: {
      primary: 'bg-primary text-white',
      secondary: 'bg-secondary text-white',
      tertiary: 'bg-tertiary text-white',
      black: 'bg-black text-white',
      white: 'bg-white text-primary',
      success: 'bg-success text-white',
      good: 'bg-good text-white',
      neutral: 'bg-neutral text-white',
      info: 'bg-info text-white',
      error: 'bg-error text-white',
      warning: 'bg-warning text-white'
    },
    size: {
      xs: 'h-4 min-w-4 px-1 pb-[1px] text-[8px] font-bold leading-3',
      sm: 'h-5 min-w-5 px-1 text-2xs font-bold',
      md: 'h-6 min-w-6 px-2 text-xs font-bold'
    },
    variant: {
      default: '',
      toned: ''
    }
  },
  compoundVariants: [
    {
      color: 'primary',
      variant: 'toned',
      class: 'bg-primary/10 text-primary'
    },
    {
      color: 'secondary',
      variant: 'toned',
      class: 'bg-secondary/10 text-secondary'
    },
    {
      color: 'tertiary',
      variant: 'toned',
      class: 'bg-tertiary/10 text-tertiary'
    },
    {
      color: 'success',
      variant: 'toned',
      class: 'bg-success-surface text-success'
    },
    {
      color: 'info',
      variant: 'toned',
      class: 'bg-info/10 text-info'
    },
    {
      color: 'good',
      variant: 'toned',
      class: 'bg-good/10 text-good'
    },
    {
      color: 'neutral',
      variant: 'toned',
      class: 'bg-neutral/10 text-neutral'
    },
    {
      color: 'error',
      variant: 'toned',
      class: 'bg-error/10 text-error'
    },
    {
      color: 'warning',
      variant: 'toned',
      class: 'bg-warning-surface text-warning'
    },
    {
      color: 'black',
      variant: 'toned',
      class: 'bg-black/40 text-black'
    },
    {
      color: 'white',
      variant: 'toned',
      class: 'bg-white/40 text-white'
    }
  ],
  defaultVariants: {
    size: 'md',
    color: 'primary',
    variant: 'default'
  }
});
